module.exports = __webpack_public_path__ + "img/payhere_banner.8548f2e4.png";